import React from 'react';
import {connect} from 'react-redux';
import {List} from 'immutable';
import {Tags, TextInput, H3, Flex, SVGButton} from '/app/src/component/'
import Modal from 'react-responsive-modal';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';
import CustomerSelector from '/app/src/model/Customer/selector';
import CustomerModel from '/app/src/model/Customer/model';

import style from './style.css';

class CustomerInfo extends React.Component {
    constructor(props) {
        super(props);

        this._onInputChange = this._onInputChange.bind(this)
        this._onCustomerSaveInfo = this._onCustomerSaveInfo.bind(this)
        this._handleTagAddition = this._handleTagAddition.bind(this)
        this._handleTagDeletion = this._handleTagDeletion.bind(this)
        this._resetState = this._resetState.bind(this)

        this._closeModal = this._closeModal.bind(this)
        this._openModal = this._openModal.bind(this)
        this._blockCustomer = this._blockCustomer.bind(this)
        this._renderBlockedButton = this._renderBlockedButton.bind(this)

        var customer = props.customer;
        this.state = {
            cutomer: customer,
            id: CustomerSelector.getId(customer),
            name: CustomerSelector.getName(customer, ''),
            email: CustomerSelector.getEmail(customer, ''),
            phone: CustomerSelector.getPhone(customer, ''),
            note: CustomerSelector.getNote(customer, ''),
            tags: CustomerSelector.getTags(customer, List()),
            blocked: CustomerSelector.getIsBlocked(customer, false),
            modalConfirmBlockCustomer: false

        }
    }
    _closeModal(){
        this.setState({ modalConfirmBlockCustomer: false });
    }
    _openModal(){
        if(!this.state.blocked){
            this.setState({modalConfirmBlockCustomer: true})
        }else {
            this.props.dispatch(CustomerModel.updateToDB(this.state.id, {updates:{is_blocked: false}}))
        }
    }
    _blockCustomer(block){
        return (event)=> {
            this.props.dispatch(CustomerModel.updateToDB(this.state.id, {updates:{is_blocked: block}}))
        }
    }


    _resetState(customer){
        this.setState({
                cutomer: customer,
                id: CustomerSelector.getId(customer),
                name: CustomerSelector.getName(customer, ''),
                email: CustomerSelector.getEmail(customer, ''),
                phone: CustomerSelector.getPhone(customer, ''),
                note: CustomerSelector.getNote(customer, ''),
                tags: CustomerSelector.getTags(customer, List()),
                blocked: CustomerSelector.getIsBlocked(customer, false),
                modalConfirmBlockCustomer: false

        })
    }

    _onInputChange(e) {
        e.persist()
        this.setState((prevState) => {
            prevState[e.target.name] = e.target.value
            return prevState;
        });
    }

    componentWillReceiveProps(nextProps){
        var customer = nextProps.customer;
        this._resetState(customer);
    }

    _onCustomerSaveInfo(e) {
        e.preventDefault()
        const name = this.state.name;
        const email = this.state.email;
        const phone = this.state.phone;
        const note = this.state.note;
        const id = this.state.id;
        var payload = {updates:{
          'name': name,
          'note': note,
          'email': email,
          'phone': phone,
        }}
       this.props.dispatch(CustomerModel.updateToDB(id, payload));
    }
    _handleTagAddition(tag){
        let color = 'black';
        const customerId = this.state.id
        this.props.dispatch(CustomerModel.createTag(customerId, tag, color));
    }
    _handleTagDeletion(tag){
        const tagId = this.state.tags.getIn([tag, 'id']);
        const customerId = this.state.id
        this.props.dispatch(CustomerModel.deleteTag(customerId, tagId));
    }
    __copyNotification(){
        return(
            toast.info("Kopierat till urklipp")
        );
    }
    _craftInput(name, label){
        const value = this.state[name]? this.state[name]: '';

        return (
            <Flex marginTop='10px' width='100%' column shrink={0}>
                <H3 marginLeft='5px'> {label} </H3>
                <Flex vAlignContent='center'>
                    <TextInput
                        name={name}
                        placeholder={label}
                        value={value}
                        onChange={(event) => this._onInputChange(event)}
                        width='auto !important'
                        grow
                    />
                    <CopyToClipboard text={value}>
                    <SVGButton src='/images/Chat_QuickResponse.svg' onClick={this.__copyNotification} hover='blue' className={style.CopyButton}/>
                    </CopyToClipboard>
                </Flex>
            </Flex>
        )
    }
    _renderBlockedButton(){
        const {blocked} = this.state
        return  <SVGButton
                src='/images/BlockVisitor.svg'
                h='40px'
                border
                marginRight='auto'
                fontSize='18px'
                color='black'
                title='Blockera användare från att skriva i chatten'
                text={blocked&&'Häv blockering'}
                hover={blocked?'blue':'red'}
                onClick={this._openModal}
            />
    }

    render() {
        if(!this.props.customer)
            return null;
        const noteValue = this.state.note? this.state.note: '';

        return (
            <Flex hAlignContent='center' column  width='100%' px='5%' mt='20px' shrink={0}>
                <Flex hAlignContent='right' width='100%' shrink={0}>
                    {this._renderBlockedButton()}
                    <SVGButton
                        src='/images/Save.svg'
                        text='Spara'
                        color='black' hover='blue'
                        w='100px' h='40px'
                        border
                        fontSize='18px'
                        onClick={this._onCustomerSaveInfo}
                    />

                </Flex>
                {this._craftInput('name', 'Namn')}
                {this._craftInput('email', 'E-mail')}
                {this._craftInput('phone', 'Telefon Nr.')}
                <Flex marginTop='10px' width='100%' column shrink={0}>
                    <H3 marginLeft='5px'> Anteckningar </H3>
                    <textarea className={style.TextArea}
                        name='note'
                        value={noteValue}
                        onChange={this._onInputChange}
                        rows={5}
                    />
                </Flex>
                <Flex width='100%' wrap>
                <Tags
                    tags={this.state.tags.toJS()}
                    handleDelete={this._handleTagDeletion}
                    handleAddition={this._handleTagAddition}
                    allowDeleteFromEmptyInput={false}
                    placeholder=' +  Lägg till'
                    id='tags'
                />
                </Flex>


                <Modal
                    styles={{
                        modal:{
                            width: '600px',
                            height: '250px',
                            borderRadius: '20px',
                            padding: '0px'
                        }
                    }}

                showCloseIcon={false} open={this.state.modalConfirmBlockCustomer} onClose={this._closeModal} center>
                    {this._renderModal()}
                </Modal>

            </Flex>
        )
    }

    _renderModal(){
        return(
            <Flex w='600px' h='250px' overflow='hidden' borderRadius='20px' column>
                <Flex
                    w='100%' h='63px'
                    backgroundColor='#404040' color='blue'
                    center fontSize='28px' fontWeight='500'
                    borderBottom='5px solid'
                >
                    Är du säker?
                </Flex>
                <Flex grow column hAlignContent='center' w='100%' pb='20px'>
                    <Flex marginTop='30px' textAlign='center' fontSize='20px' fontWeight='300' center w='70%'>
                        Nästa gång kunden kommer till din hemsidan kommer kunden inte kunna ser ClientChat
                    </Flex>
                    <Flex center mt='10px'>

                        <SVGButton
                            src='/images/Return.svg'
                            text='Tillbaka'
                            color='black' hover='blue'
                            w='124px' h='40px'
                            fontSize='18px'
                            border marginRight='20px'
                            onClick={this._closeModal}
                        />

                        <SVGButton
                            src='/images/BlockVisitor.svg'
                            text='Blockera'
                            color='black' hover='red'
                            w='124px' h='40px'
                            border
                            fontSize='18px'
                            onClick={this._blockCustomer(true)}
                        />
                    </Flex>
                </Flex>


            </Flex>
        )
    }

}


export default connect()(CustomerInfo);



// WEBPACK FOOTER //
// ./src/container/Customer/CustomerInfo.js